import React, { useState } from "react";
import AgregarProducto from "../AgregarProducto/AgregarProducto";
import StockActual from "../StockActual/StockActual";
import ExportarStock from "../ExportarStock/ExportarStock";
import OrdenesAdmin from "../OrdenesAdmin/OrdenesAdmin"; // 👈 Importamos el nuevo componente

export default function AdminPanel({ user }) {
  const [activeTab, setActiveTab] = useState("stock");

  return (
    <div className="p-6 bg-gray-100 rounded-lg shadow-lg">
      <h2 className="text-2xl font-bold mb-4">Panel de Administración</h2>
      <p className="mb-6">Bienvenido jefe: {user.email}</p>

      <div className="flex space-x-4 mb-6">
        <button 
          onClick={() => setActiveTab("stock")} 
          className={`px-4 py-2 rounded ${activeTab === "stock" ? "bg-blue-500 text-white" : "bg-gray-200"}`}
        >
          📦 Ver Stock
        </button>

        <button 
          onClick={() => setActiveTab("agregar")} 
          className={`px-4 py-2 rounded ${activeTab === "agregar" ? "bg-blue-500 text-white" : "bg-gray-200"}`}
        >
          ➕ Agregar Producto
        </button>

        <button 
          onClick={() => setActiveTab("exportar")} 
          className={`px-4 py-2 rounded ${activeTab === "exportar" ? "bg-blue-500 text-white" : "bg-gray-200"}`}
        >
          📥 Exportar
        </button>

        <button 
          onClick={() => setActiveTab("ordenes")} 
          className={`px-4 py-2 rounded ${activeTab === "ordenes" ? "bg-blue-500 text-white" : "bg-gray-200"}`}
        >
          📑 Órdenes
        </button>
      </div>

      {activeTab === "stock" && <StockActual />}
      {activeTab === "agregar" && <AgregarProducto />}
      {activeTab === "exportar" && <ExportarStock />}
      {activeTab === "ordenes" && <OrdenesAdmin />} {/* 👈 Agregamos la nueva pestaña */}
    </div>
  );
}